import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './CTAButton.css';
import { Link } from 'react-router-dom';
import { generateDynamicCSS } from '../../ComponentsMap';

const CTAButton = ( props ) => {
    useEffect(() => {
        generateDynamicCSS(props?.className, props.style?[props.style]:[]);
        
    }, []);
    return (    
        <>
            {props.type === 'link' ?
                <Link
                    className={`cta-button col ${props.className}`}
                    type={props.type}
                    to={props.link}
                    disabled={props.disabled}
                >
                    {props.label}
                </Link> :
                <button
                    className={`cta-button col ${props.className}`}
                    onClick={props.onClick}
                    type={props.type}
                    disabled={props.disabled}
                >
                    {props.label}
                </button>
            }
        </>


    );
};

CTAButton.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    type: PropTypes.oneOf(['button', 'submit', 'reset', 'link']),
    disabled: PropTypes.bool
};

export default CTAButton;